/* @generated from adl module ferovinum.sourcecontracts.organisationregistration */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.organisation_registration` contract.
 */
export interface OrganisationRegistrationSource {
  id: common_db.DbKey<ferovinum_app_db.OrganisationRegistration>;
  organisationId: ferovinum_app_db.OrganisationId;
  country: common_strings.StringNE;
  scheme: common_strings.StringNE;
  identifier: (common_strings.StringNE|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeOrganisationRegistrationSource(
  input: {
    id: common_db.DbKey<ferovinum_app_db.OrganisationRegistration>,
    organisationId: ferovinum_app_db.OrganisationId,
    country: common_strings.StringNE,
    scheme: common_strings.StringNE,
    identifier: (common_strings.StringNE|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): OrganisationRegistrationSource {
  return {
    id: input.id,
    organisationId: input.organisationId,
    country: input.country,
    scheme: input.scheme,
    identifier: input.identifier,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const OrganisationRegistrationSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.organisationregistration","decl":{"annotations":[{"value":{"modelName":"source__app_db.organisation_registration","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.organisation_registration` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationRegistration"}},"parameters":[]}]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"country","default":{"kind":"nothing"},"name":"country","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"scheme","default":{"kind":"nothing"},"name":"scheme","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"identifier","default":{"kind":"nothing"},"name":"identifier","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"OrganisationRegistrationSource","version":{"kind":"nothing"}}};

export const snOrganisationRegistrationSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.organisationregistration", name:"OrganisationRegistrationSource"};

export function texprOrganisationRegistrationSource(): ADL.ATypeExpr<OrganisationRegistrationSource> {
  return {value : {typeRef : {kind: "reference", value : snOrganisationRegistrationSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.organisationregistration.OrganisationRegistrationSource" : OrganisationRegistrationSource_AST
};
